import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import { fetchComisionistDetail } from 'redux/actions/comisionist.actions';
import { NewComisionistScreen } from './NewComisionistScreen';
import { Routes } from 'config/routes';

/**
 * Wrapper componente para la página de creación/edición de comisionista
 * Maneja los query params y la navegación
 */
const NewComisionistPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useThunkDispatch();
  const { selectedComisionist, isLoading } = useTypedSelector((s) => s.comisionist);
    const branchOffices = useTypedSelector((s) => s.catalog.offices);

  const [initialData, setInitialData] = useState<any>(null);
  //



  useEffect(() => {
    // Parsear query params
    const searchParams = new URLSearchParams(location.search);
    const mode = searchParams.get('mode'); // 'crear' o 'editar'
    const id = searchParams.get('id'); // ID del comisionista si es editar

    // Si es modo editar, obtener datos del comisionista del API
    if (mode === 'editar' && id) {
      dispatch(fetchComisionistDetail(id));
    } else if (mode !== 'crear') {
      // Si no hay modo válido, redirigir a la lista
      history.push(Routes.comisionist);
    }
  }, [location.search, history, dispatch]);

  // Mapear selectedComisionist a initialData cuando esté disponible
  useEffect(() => {
    if (selectedComisionist) {
      setInitialData({
        name: selectedComisionist.name || '',
        type: selectedComisionist.type,
        dui: selectedComisionist.dui || '',
        nit: selectedComisionist.nit || '',
        nrc: selectedComisionist.nrc || '',
        branchOfficeId: selectedComisionist.branchOfficeId || '',
        zoneId: branchOffices.data.find((o) => o.id === selectedComisionist.branchOfficeId)?.zone?.id || 0,
        isLargeContributor: selectedComisionist.isLargeContributor ?? false,
        status: selectedComisionist.status,
        documentsStatus: selectedComisionist.documentsStatus,
        clientAccount: selectedComisionist.account,
        identityDoc: selectedComisionist.identityDoc,
        nrcDoc: selectedComisionist.nrcDoc,
        signedFile: selectedComisionist.signedFile,
        dateDischarge: selectedComisionist.dateHighAS400 || '',
        verified: selectedComisionist.verified ,
      });
    }
  }, [selectedComisionist]);

  const handleClose = () => {
    history.push(Routes.comisionist);
  };

  const handleSuccess = () => {
    history.push(Routes.comisionist);
  };

  return (
    <NewComisionistScreen
      onClose={handleClose}
      onSuccess={handleSuccess}
      initialData={initialData}      isLoadingData={isLoading}    />
  );
};

export default NewComisionistPage;
